import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export interface GetSpecialistsArgs {
  locale: string
  serviceCategoryId?: string
}

export type Image = {
  id: number
  attributes: {
    name: string
    alternativeText?: string
    caption?: string
    width?: number
    height?: number
    url: string
  }
}

export type ServiceCategory = {
  id: number
  attributes: {
    name: string
    slug: string
  }
}

export type Service = {
  id: number
  attributes: {
    name: string
    slug: string
    categories: {
      data: ServiceCategory[]
    }
  }
}

export type Specialty = {
  id: number
  attributes: {
    name: string
    slug: string
  }
}

export type SpecialistCard = {
  id: number
  attributes: {
    academic_degree: string
    name: string
    order: number
    photo: MediaObject | null
    services: { data: Service[] }
    slug: string
    specialties: { data: Specialty[] }
  }
}

export type SpecialistsList = {
  data: SpecialistCard[]
}

export const getSpecialistsInSpecialistsPageBlock = async (
  client: AxiosInstance,
  { locale, serviceCategoryId }: GetSpecialistsArgs,
) => {
  const path = `/specialists`
  const params = {
    locale,
    sort: ['order:asc', 'name:asc', 'id:asc'],
    fields: ['name', 'slug', 'order', 'academic_degree'],
    populate: {
      photo: {
        fields: ['id', 'width', 'height', 'url'],
      },
      services: {
        fields: ['name', 'id'],
      },
      specialties: {
        fields: ['name', 'id'],
      },
    },
    filters: {
      ...(serviceCategoryId
        ? {
            services: {
              categories: {
                id: {
                  $eq: serviceCategoryId,
                },
              },
            },
          }
        : {}),
    },
  }
  return (await client.get<SpecialistsList>(path, { params })).data.data
}
